import { FunctionComponent } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { TextField } from '@mui/material';
import { CreateTransactionModalFormModel } from '../CreateTransactionModal/CreateTransactionModalFormModel';
import { useTranslation } from '@/lib';

interface TransactionReferenceNumberFieldProps {
  control: Control<CreateTransactionModalFormModel>;
  errors: FieldErrors<CreateTransactionModalFormModel>;
  disabled?: boolean;
}

export const TransactionReferenceNumberField: FunctionComponent<TransactionReferenceNumberFieldProps> = ({ control, errors, disabled }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="referenceNumber"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label={t('reference_number')}
          error={errors.referenceNumber !== undefined}
          helperText={errors.referenceNumber?.message}
          disabled={disabled}
        />
      )}
    />
  );
};
